import { Injectable }       from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Route
}                           from '@angular/router';
import { AlertService,UserService } from '../_services/index';
import { environment } from '../../environments/environment';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { NgxPermissionsService } from 'ngx-permissions';
import { any } from 'underscore';

@Injectable()
export class AuthGuard implements CanActivate {
    backendUrl : any;
    constructor(private userService: UserService, private router: Router,private alertService : AlertService,
        private permissionsService: NgxPermissionsService, private http: Http) {
        this.backendUrl=environment.url;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.checkLogin(state);
    }

    checkLogin(state:any): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            let user_id= -1
                if(currentUser){
                   user_id = currentUser.user_id; 
                }
            this.userService.isLoggedIn(user_id).then((resp :any ) => {
              if(resp && resp.hasOwnProperty('status') && resp.status == 'success'){ 
                let route_name = state.url;
                let role_id = currentUser.role_id;
                var r_arr = route_name.split('/');
                if(r_arr.length > 2) {
                    route_name = "/"+r_arr[1];
                }
                this.userService.getUserPermissionByRouteName(this.backendUrl,JSON.stringify({'role_id': role_id,'route_name':route_name}))
                .subscribe(data => {
               
                        this.permissionsService.flushPermissions();
                        this.permissionsService.loadPermissions(data);
                        var permissions = this.permissionsService.getPermissions();
                        var prem = Object.keys(permissions)[0];
                        localStorage.removeItem('permission');
                        localStorage.setItem('permission', prem);                    
                        resolve(true);
                }, error => {
                    if(error.status==401){
                        this.http.get(this.backendUrl + '/generate_token', JSON.stringify({}))
                        .map(res => res.json())
                        .subscribe(response => {
                            (localStorage.getItem('id_token') != undefined) ? localStorage.setItem('id_token',response.token) :  localStorage.setItem('login_token', response.token);
                         
                           location.reload()
                        }
                        );
                    }

                  });
              }else{
                this.router.navigate(['/login']);
                reject(false);  
              }               
            }).catch((e) => {
                if(e == false){
                  this.alertService.error('Sorry, You are not authorized to access.Please try again.');
                }                
                this.router.navigate(['/login']);
                reject(false);
            });
        });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_guards/auth.guard.ts